import { CreateMixin } from "@pdfking/reactivity/preact"

export const RootMixin = CreateMixin({
  data: {
    root: null as HTMLElement | null,
  },
  mounted(el: HTMLElement) {
    this.root = el
  },
})
